import { useSelector } from 'react-redux';
import { selectEssSwitch } from 'shared/slice/essSwitchSlice';
import { selectTesSwitch } from 'shared/slice/tesSwitchSlice';
import { selectTgsSwitch } from 'shared/slice/tgsSwitchSlice';

import styled from 'styled-components';
import { selectUnits } from 'shared/slice/unitsSlice';
import { useMemo } from 'react';
import { calculateTotalEnergyConsumption } from 'shared/helpers/helpers';
import Gauge from './Gauge';
import { statCard } from 'shared/styles/theme';


const TOTAL_ENERGY_MAX = 1000;

const DisplayConsumptionBox = ({ swtName, location, machine }) => {
  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;
  const { flatEssSwitch,flatTgsSwitch,flatTesSwitch } = useSelector(
    swtName === 'ess'
      ? selectEssSwitch
      : swtName === 'tgs'
      ? selectTgsSwitch
      : selectTesSwitch
  );

  const swtStatus = swtName === 'ess' ? flatEssSwitch : swtName === 'tgs' ? flatTgsSwitch : flatTesSwitch;


  const gas = isF ? 'FT³' : 'M³';
  const unit = swtName === 'tgs' ? gas : 'kw';

  const consumption = useMemo(() => {
    return calculateTotalEnergyConsumption(swtStatus[location][machine]?.reading, swtName, isF);
  }, [swtStatus, location, machine, swtName, isF]);

  const ratio =
    typeof consumption === 'number'
      ? Math.max(0, Math.min(1, consumption / TOTAL_ENERGY_MAX))
      : 0;

  return (
    <Card>
      <Gauge
        ratio={ratio}
        icon='/images/stats-figma/stat-total-energy.png'
        alt='total energy consumption'
        size={52}
        stroke={5}
      />
      <Info>
        <Value>
          {consumption} <Unit>{unit}</Unit>
        </Value>
        <Title>total {swtName === 'tgs' ? 'gas' : 'energy'} consumption</Title>
      </Info>
    </Card>
  );
};

export default DisplayConsumptionBox;

const Card = styled.div`
  width: 230px;
  height: 72px;
  border-radius: 14px;

  background: ${statCard.totalBg};
  border: 0.8px solid ${statCard.totalBorder};
  box-shadow: 0px 1px 1.5px rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 10px;
`;
const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;
const Value = styled.span`
  display: flex;
  align-items: baseline;
  gap: 3px;
  font-size: 16px;
  font-weight: 700;
  color: ${statCard.totalValue};
  text-transform: capitalize;
`;
const Unit = styled.span`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
`;
const Title = styled.span`
  font-size: 8px;
  font-weight: 600;
  color: ${statCard.totalLabel};
`;
